import { Minus, Plus } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const Btn = ({ onClick, disabled, testid, label, children }) => (
  <button type="button" onClick={onClick} disabled={disabled} data-testid={testid} aria-label={label}
    className="w-12 h-12 rounded-full border-2 border-ink grid place-items-center bg-white hover:bg-butter active:scale-90 transition-[background-color,transform] duration-200 disabled:opacity-40">
    {children}
  </button>
);

export const QuantityPicker = ({ qty, setQty }) => (
  <div className="flex items-center gap-4">
    <Btn onClick={() => setQty(Math.max(1, qty - 1))} disabled={qty <= 1} testid="quantity-decrease-button" label="Fewer copies"><Minus className="w-5 h-5" /></Btn>
    <div className="relative w-14 h-14 overflow-hidden grid place-items-center" data-testid="quantity-input">
      <AnimatePresence initial={false}>
        <motion.span key={qty} initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -30, opacity: 0 }}
          className="absolute font-display text-4xl">{qty}</motion.span>
      </AnimatePresence>
    </div>
    <Btn onClick={() => setQty(Math.min(20, qty + 1))} disabled={qty >= 20} testid="quantity-increase-button" label="More copies"><Plus className="w-5 h-5" /></Btn>
  </div>
);
